import { PcvizExpressionObject } from '@mirage-projects/cw-models';

type SymbolOperators = '=' | '<' | '>' | '<=' | '>=' | '!=' | '~';

export interface Operator {
    symbol: SymbolOperators;
    tip:
        | 'EXPRESSION_EDITOR.EQ_TOOLTIP'
        | 'EXPRESSION_EDITOR.LESS_TOOLTIP'
        | 'EXPRESSION_EDITOR.LARGE_TOOLTIP'
        | 'EXPRESSION_EDITOR.LEQ_TOOLTIP'
        | 'EXPRESSION_EDITOR.GEQ_TOOLTIP'
        | 'EXPRESSION_EDITOR.NOTEQ_TOOLTIP'
        | 'EXPRESSION_EDITOR.CONTAINS_TOOLTIP';
    useWithBool: boolean;
}

const operators: Readonly<Operator[]> = [
    {
        symbol: '=',
        tip: 'EXPRESSION_EDITOR.EQ_TOOLTIP',
        useWithBool: true,
    },
    {
        symbol: '<',
        tip: 'EXPRESSION_EDITOR.LESS_TOOLTIP',
        useWithBool: false,
    },
    {
        symbol: '>',
        tip: 'EXPRESSION_EDITOR.LARGE_TOOLTIP',
        useWithBool: false,
    },
    {
        symbol: '<=',
        tip: 'EXPRESSION_EDITOR.LEQ_TOOLTIP',
        useWithBool: false,
    },
    {
        symbol: '>=',
        tip: 'EXPRESSION_EDITOR.GEQ_TOOLTIP',
        useWithBool: false,
    },
    {
        symbol: '!=',
        tip: 'EXPRESSION_EDITOR.NOTEQ_TOOLTIP',
        useWithBool: true,
    },
    {
        symbol: '~',
        tip: 'EXPRESSION_EDITOR.CONTAINS_TOOLTIP',
        useWithBool: false,
    },
] as const;

type Operators = (typeof operators)[number][];
type ExpresionTypes = 'EXPRESSION_EDITOR.ALWAYS_TRUE' | 'EXPRESSION_EDITOR.CUSTOM' | 'EXPRESSION_EDITOR.PREDEFINED';

export type FieldExpressionItem = { id: string; type: string };

/**
 * Class that represents the state of the expression editor.
 */
export class ExpressionConfig {
    isValid = true;
    exprType: ExpresionTypes = 'EXPRESSION_EDITOR.ALWAYS_TRUE';
    useAnd = false;
    field = 'field1';
    fieldsExpression: FieldExpressionItem[] = [
        { id: 'field1', type: 'TextField' },
        { id: 'field2', type: 'TextField' },
        { id: 'intFieldTest', type: 'IntegerField' },
    ];
    operators: Readonly<Operators> = operators;
    value1: string | number | boolean = 1;
    value2: string | number | boolean = 4;
    op1 = '>';
    op2 = '<=';
    customExpr = '[testField] != [anotherField] + 3';
}

export interface ExpressionEvent {
    expressionObject: PcvizExpressionObject;
    expression: string;
    isValid: boolean;
}
